export default __webpack_public_path__ + "static/media/bgre.3c68d1a5.png";